import { useUser } from '@trustpad/launchpad';
import dayjs from 'dayjs';
import * as React from 'react';
import { IS_DEV } from '~config/constants';
import { useDHControllerContract } from '~features/diamondHands/useDHControllerContract';
import { AddressWithLink } from '~features/pools/components/PoolSecondaryBlock/AddressWithLink';

export function DHAdmin({ dhUser, distribution, refresh }) {
  const { account } = useUser();
  const dhController = useDHControllerContract();
  const startRef = React.useRef<HTMLInputElement>(null);

  if (!IS_DEV) return null;

  function setDistributionDate(v: string) {
    const date = new Date(v);
    console.log('setDistributionDate', v, date);
    dhController.methods
      .setDistributionStart(0, Math.round(date.getTime() / 1000))
      .send({ from: account })
      .then(() => refresh());
  }

  return (
    <div>
      <div>
        <label htmlFor="distribution-start">Distribution start</label>
        <input
          ref={startRef}
          name="distribution-start"
          type="datetime-local"
          defaultValue={
            distribution?.start
              ? dayjs.unix(distribution.start).format('YYYY-MM-DDTHH:mm')
              : ''
          }
          className="bg-gray-800 text-gray-100 ml-2"
        />
        <button onClick={() => setDistributionDate(startRef.current.value)}>
          Set
        </button>
      </div>
      <div className="text-xs">
        <p className="mb-3">User status</p>
        <pre>{JSON.stringify(dhUser, null, 2)}</pre>
        <p className="mb-3">Distribution stats</p>
        <pre>{JSON.stringify(distribution, null, 2)}</pre>
      </div>
      <AddressWithLink
        address={process.env.DH_CONTROLLER_ADDRESS}
        label="DHController"
      />
    </div>
  );
}
